import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row justify-content-center"
};
const _hoisted_2 = {
    class: "col-xs-12 col-md-8 mt-5",
    id: "block_error"
};
const _hoisted_3 = { class: "text-warning" };
const _hoisted_4 = { class: "text-secondary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.statusCode === 403)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Opps! Keine Berechtigung...", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", null, " Für diese Funktion haben Sie keine Berechtigung. ", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("p", null, [
                        _createTextVNode(" Für weitere Fragen wenden Sie sich bitte an Ihren Helpdesk. "),
                        _createElementVNode("br"),
                        _createElementVNode("br"),
                        _createTextVNode("Vielen Dank. ... ;) ")
                    ], -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("table", _hoisted_3, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[0] || (_cache[0] = _createElementVNode("td", { style: { "padding-right": "50px" } }, "Zeitstempel:", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$utils.formatDate(Date.now(), 'date-time')), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[1] || (_cache[1] = _createElementVNode("td", null, "Fehler:", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$utils.createId()), 1)
                            ]),
                            (_ctx.statusProperties)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.statusProperties, (value, name, index) => {
                                    return (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                        _createElementVNode("td", null, _toDisplayString(name) + ":", 1),
                                        _createElementVNode("td", null, _toDisplayString(value), 1)
                                    ]));
                                }), 256))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ])
        ]))
        : (_ctx.statusCode === 0 || _ctx.statusCode === 200)
            ? _renderSlot(_ctx.$slots, "default", { key: 1 })
            : _createCommentVNode("", true);
}
